export function appInitializerFactory() {
  return () =>
    new Promise((resolve) => {
      window['fbAsyncInit'] = () => {
        FB.init({
          appId: '410704994420165',
          cookie: true,
          xfbml: true,
          version: 'v18.0',
        });
      };

      // load facebook sdk script
      (function (d, s, id) {
        const fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        const js = d.createElement(s);
        js.id = id;
        (js as any).src = 'https://connect.facebook.net/en_US/sdk.js';
        (fjs as any).parentNode.insertBefore(js, fjs);
      })(document, 'script', 'facebook-jssdk');

      resolve(true);
    });
}
